export const INDIAN_INDICES = ["NIFTY", "BANKNIFTY", "SENSEX", "FINNIFTY", "MIDCPNIFTY"];
export const GLOBAL_INDICES = ["SPX", "SP500", "NASDAQ", "NDX", "DAX", "FTSE", "N225", "HSI", "VIX"];

export function segmentOf(symbol, category = "", tvSymbol = "") {
  const s = (symbol || "").toUpperCase();
  const c = (category || "").toLowerCase();
  if (INDIAN_INDICES.includes(s)) return "indian";
  if (GLOBAL_INDICES.includes(s)) return "global";
  const ex = tvSymbol && tvSymbol.includes(":") ? tvSymbol.split(":")[0].toUpperCase() : "";
  if (ex === "NSE" || ex === "BSE") return "indian";
  if (ex) return "global";
  if (c === "stock" || c === "index") return "indian";
  return "global";
}
